<router-outlet />
@if (!environment.production) {
  <angular-query-devtools />
}
